import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Footer() {
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  const content = {
    privacy: {
      title: 'Política de Privacidad',
      body: 'Respetamos tu privacidad. Los datos recopilados en este sitio se utilizan exclusivamente para procesar tu compra y enviarte el material digital adquirido. No compartimos, vendemos ni alquilamos tu información personal a terceros. Al realizar una compra, aceptas que te enviemos correos electrónicos relacionados con tu pedido y actualizaciones del producto.'
    },
    terms: {
      title: 'Términos y Condiciones',
      body: 'Este producto es una guía informativa y no reemplaza el consejo, diagnóstico o tratamiento de un médico veterinario profesional. El autor no se hace responsable por el mal uso de la información contenida en la guía. Al comprar este producto digital, aceptas que no hay devoluciones una vez descargado el material, dada su naturaleza digital.'
    }
  };
  return <>
      <footer className="bg-neutral-950 py-12 px-4 border-t border-neutral-900" data-id="element-41">
        <div className="container mx-auto max-w-5xl flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-42">
          <div className="text-neutral-500 text-sm" data-id="element-43">
            © {new Date().getFullYear()} Protocolo de 60 Segundos. Todos los
            derechos reservados.
          </div>

          <div className="flex gap-6" data-id="element-44">
            <button onClick={() => setModalContent('privacy')} className="text-neutral-500 hover:text-brand transition-colors text-sm" data-id="element-45">
              Política de Privacidad
            </button>
            <button onClick={() => setModalContent('terms')} className="text-neutral-500 hover:text-brand transition-colors text-sm" data-id="element-46">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Legal Modal */}
      <AnimatePresence data-id="element-47">
        {modalContent && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-48">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setModalContent(null)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-49" />

            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative bg-neutral-900 border border-neutral-800 rounded-2xl p-8 max-w-lg w-full shadow-2xl z-10" data-id="element-50">
              <button onClick={() => setModalContent(null)} className="absolute top-4 right-4 text-neutral-500 hover:text-white transition-colors" data-id="element-51">
                <X size={24} data-id="element-52" />
              </button>

              <h3 className="text-2xl font-display text-white mb-4" data-id="element-53">
                {content[modalContent].title}
              </h3>

              <div className="text-neutral-400 leading-relaxed" data-id="element-54">
                <p data-id="element-55">{content[modalContent].body}</p>
              </div>

              <button onClick={() => setModalContent(null)} className="mt-8 w-full bg-neutral-800 hover:bg-neutral-700 text-white font-medium py-3 rounded-lg transition-colors" data-id="element-56">
                Cerrar
              </button>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}